import { Component } from 'react'
import { connect } from 'react-redux'
import s from './Profile.scss'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { Container, Row, Col, Form, FormGroup, Label, Input, Button } from 'reactstrap'
import Select from 'react-select'
import { FaRegImage, FaFileSignature, FaKey, FaSignInAlt } from 'react-icons/fa'
import {
  ProfilePhoto,
  PhotoCropper,
  GoogleAutocomplete,
  KeyValuePairs
} from 'components/ideal-core-ui'
import { getUser, getToken } from 'utils/authService'
import { NotificationList } from 'components/common/NotificationList'
import {
  GET_USER_FETCH_REQUESTED,
  SAVE_USER_FETCH_REQUESTED,
  UPDATE_USER_IMAGE_FETCH_REQUESTED,
  CHANGE_PASSWORD_FETCH_REQUESTED
} from './actions'
import { convertFromProfile, convertToProfile, toDepartments } from './serializers'
import { INTEGRATIONS } from 'utils/constants'
import cn from 'classnames'
import { makeGetRequest, makePutRequest } from 'utils/api'
import moment from 'moment-timezone'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'
import { toTeams } from 'utils/serializers'
import SignatureModal from './SignatureModal/SignatureModal'

const selectGoogleAutocomplete = (e, values, setFieldValue) => {
  values.address = e.address
  values.city = e.city || ''
  values.state = e.state
  values.address2 = e.street
  values.zipcode = e.zipCode || ''
  setFieldValue('address', values.address)
}

const blurGoogleAutocomplete = (values, setFieldValue) => {
  setFieldValue('address', values.address)
}

@connect(({ admin }) => {
  return {
    admin
  }
})
class ProfileContainer extends Component {
  state = {
    fileProfile: null,
    cropProfile: null,
    isUpdateProfile: false,
    departments: [],
    olkUrls: null,
    smtpEmail: '',
    smtpPasswords: '',
    firstRender: true,
    showCredentialsForm: true,
    allTeams: [],
    signature: null,
    isSignatureModalVisible: false
  }

  async componentDidMount() {
    const { id } = getUser()
    if (id) {
      this.props.dispatch({
        type: GET_USER_FETCH_REQUESTED,
        payload: { id }
      })
      const response = await makeGetRequest('/v1/departments')
      this.setState({
        departments: response.content
      })
      const { timezones } = await makeGetRequest('/v1/timezones')
      this.setState({
        timezones: timezones.map(r => ({
          value: r,
          label: `${r} (current ${moment().tz(r)})`
        }))
      })
      const olkUrls = await makeGetRequest('/v1/olk/config')
      this.setState({
        olkUrls
      })
      const allTeams = await makeGetRequest('/v1/teams')
      this.setState({
        allTeams
      })
      const signature = await makeGetRequest('/v1/users/signature')
      this.setSignature(signature)
    }
  }

  componentDidUpdate() {
    if (this.state.firstRender) {
      if (!this.state.smtpEmail && this.props.admin.profile?.emailCredentials?.username) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          smtpEmail: this.props.admin.profile?.emailCredentials?.username,
          firstRender: false,
          showCredentialsForm: false
        })
      }
    }
  }

  setStateProperty = (property, value) => {
    this.setState({
      [property]: value
    })
  }

  isUpdateProfileToggle = isUpdateProfile => {
    this.setState({
      isUpdateProfile,
      fileProfile: null,
      cropProfile: null
    })
  }

  updateProfilePicture = () => {
    const { fileProfile, cropProfile } = this.state
    this.props.dispatch({
      type: UPDATE_USER_IMAGE_FETCH_REQUESTED,
      payload: {
        fileInfo: {
          file: fileProfile,
          crop: cropProfile
        }
      }
    })
    this.isUpdateProfileToggle(false)
  }

  saveUser = userBody => {
    if (getUser()) {
      const userId = getUser().id
      this.props.dispatch({
        type: SAVE_USER_FETCH_REQUESTED,
        payload: { userId, userBody }
      })
    }
  }

  changePassword = userBody => {
    this.props.dispatch({
      type: CHANGE_PASSWORD_FETCH_REQUESTED,
      payload: { userBody }
    })
  }

  handleChange = (e, values, setFieldValue, input) => {
    values[input] = e
    setFieldValue(input, e)
  }

  redirectToOutlook = () => {
    window.location = `${this.state.olkUrls.authorizeUrl}?token=${getToken()}`
  }

  signOutFromOutlook = () => {
    window.location = `${this.state.olkUrls.logoutUrl}?token=${getToken()}`
  }

  saveSmtpCredentials = async cb => {
    const { id } = getUser()
    const { smtpEmail, smtpPassword } = this.state
    const response = await makePutRequest(`/v1/users/${id}/update-mail-credentials`, {
      username: smtpEmail,
      password: smtpPassword
    })

    cb && cb()

    this.props.dispatch({
      type: PUSH_NOTIFICATION,
      payload: {
        message: <NotificationList lines={response.message} />,
        level: response.success ? 'success' : 'error',
        autoDismiss: 0
      }
    })
  }

  testSmtpConnection = async () => {
    const response = await makeGetRequest('/v1/email/validate-smtp')
    this.props.dispatch({
      type: PUSH_NOTIFICATION,
      payload: {
        message: <NotificationList lines={response.message} />,
        level: response.success ? 'success' : 'error',
        autoDismiss: 0
      }
    })
  }

  setSignature = signature => {
    this.setState({
      signature
    })
  }

  toggleSignatureModal = () => {
    this.setState(prevState => ({
      isSignatureModalVisible: !prevState.isSignatureModalVisible
    }))
  }

  render() {
    const fromProfile = convertFromProfile(this.props.admin.profile)
    const {
      firstName,
      lastName,
      title,
      phone,
      email,
      fax,
      cellPhone,
      address,
      address2,
      street2,
      city,
      state,
      zipcode,
      image,
      department,
      timezone,
      emailIntegration,
      organization,
      teams
    } = fromProfile
    const currentPassword = ''
    const newPassword = ''
    const confirmNewPassword = ''
    const departments = this.state.departments
    const allTeams = this.state.allTeams

    return (
      <>
        <Formik
          props={this.props}
          enableReinitialize
          initialValues={{
            firstName,
            lastName,
            title,
            teams,
            phone,
            email,
            fax,
            cellPhone,
            address,
            address2,
            street2,
            city,
            state,
            zipcode,
            department,
            timezone
          }}
          onSubmit={(values, { setSubmitting }) => {
            this.saveUser(convertToProfile(values))
            setSubmitting(false)
          }}
          validationSchema={Yup.object().shape({
            firstName: Yup.string().required('First Name is required'),
            lastName: Yup.string().required('Last Name is required'),
            email: Yup.string().email('Invalid Email Address').required('Email is required')
          })}
        >
          {props => {
            const {
              values,
              touched,
              errors,
              isSubmitting,
              handleBlur,
              handleChange,
              handleSubmit,
              setFieldValue
            } = props
            const { cropProfile, isUpdateProfile } = this.state
            return (
              <Container className={s.mainContainer}>
                <Row>
                  <Col xl="3">
                    <div className={s.pictureContainer}>
                      <div className={s.title}>
                        <FaRegImage className={s.faIcon} />
                        Profile Picture
                      </div>
                      <div className={s.container}>
                        {!image && (
                          <div className={s.photoCrop}>
                            <PhotoCropper
                              onFileChange={value => this.setStateProperty('fileProfile', value)}
                              onCropComplete={value => this.setStateProperty('cropProfile', value)}
                              photo={false}
                              noPreview
                            />
                            <Button
                              onClick={this.updateProfilePicture}
                              disabled={!cropProfile}
                              className={s.uploadUserImage}
                            >
                              Upload
                            </Button>
                          </div>
                        )}
                        {image && !isUpdateProfile && (
                          <>
                            <ProfilePhoto className={s.userImageContainer} src={image} />
                            <Button
                              onClick={() => this.isUpdateProfileToggle(true)}
                              className={s.uploadUserImage}
                            >
                              Change Profile Image
                            </Button>
                          </>
                        )}
                        {image && isUpdateProfile && (
                          <div className={s.photoCrop}>
                            <PhotoCropper
                              onFileChange={value => this.setStateProperty('fileProfile', value)}
                              onCropComplete={value => this.setStateProperty('cropProfile', value)}
                              photo={false}
                              noPreview
                            />
                            <Button
                              onClick={this.updateProfilePicture}
                              disabled={!cropProfile}
                              className={s.uploadUserImage}
                            >
                              Upload
                            </Button>
                            <Button
                              onClick={() => this.isUpdateProfileToggle(false)}
                              className={s.cancelButton}
                              color="secondary"
                            >
                              Cancel
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={cn(s.pictureContainer, s.signatureContainer)}>
                      <div className={s.title}>
                        <FaFileSignature className={s.faIcon} />
                        Your Signature
                      </div>
                      <div className={s.container}>
                        <div
                          className={s.signatureText}
                          dangerouslySetInnerHTML={{ __html: this.state.signature }}
                        />
                        <Button onClick={this.toggleSignatureModal} className={s.uploadUserImage}>
                          Create/Edit Signature
                        </Button>
                      </div>
                      {this.state.isSignatureModalVisible && (
                        <SignatureModal
                          signature={this.state.signature}
                          setSignature={this.setSignature}
                          isSignatureModalVisible={this.state.isSignatureModalVisible}
                          toggleSignatureModal={this.toggleSignatureModal}
                        />
                      )}
                    </div>
                    <div className={cn(s.detailsContainer, s.topMargin)}>
                      <div className={s.title}>
                        <FaSignInAlt className={s.faIcon} />
                        Connect Your Email
                      </div>
                      <div className={s.container}>
                        <div>
                          {organization?.emailIntegration === INTEGRATIONS.MAIL.IDEAL && (
                            <>
                              <p>You are sending email communications via iDeal Mail</p>
                              <p>
                                If you&#39;d like to connect your personal email, ask an Admin to
                                change the email settings in your Organization Profile -&gt;
                                Organization Email Settings
                              </p>
                            </>
                          )}
                          {organization?.emailIntegration === INTEGRATIONS.MAIL.OFFICE365 && (
                            <>
                              <p>Your Admin chose to connect via Outlook 365.</p>
                              {emailIntegration === INTEGRATIONS.MAIL.OFFICE365 ? (
                                <p>You&#39;re connected to Outlook 365</p>
                              ) : (
                                <p>Please use the wizard to connect your Outlook email.</p>
                              )}

                              <div style={{ textAlign: 'center' }}>
                                <Button
                                  onClick={
                                    !emailIntegration ||
                                    emailIntegration === INTEGRATIONS.MAIL.NON_PAYING
                                      ? this.redirectToOutlook
                                      : this.signOutFromOutlook
                                  }
                                  className={s.saveBtn}
                                >
                                  {!emailIntegration ||
                                  emailIntegration === INTEGRATIONS.MAIL.NON_PAYING
                                    ? 'Connect Your Office 365'
                                    : 'Sign Out from Office 365'}
                                </Button>
                              </div>
                            </>
                          )}
                          {organization?.emailIntegration === INTEGRATIONS.MAIL.SMTP && (
                            <>
                              <p>
                                Your Admin chose to connect an SMTP server. Please provide your
                                email and password to connect your email.
                              </p>
                              {!this.state.showCredentialsForm ? (
                                <>
                                  <p>
                                    You&#39;re connected to {organization?.emailSettings.name} with{' '}
                                    {this.state.smtpEmail}
                                  </p>
                                  <span
                                    onClick={() => {
                                      this.setState({
                                        showCredentialsForm: true
                                      })
                                    }}
                                    className={s.changeCredentials}
                                  >
                                    Change your credentials
                                  </span>
                                </>
                              ) : (
                                <>
                                  <p>You&#39;re connecting to {organization?.emailSettings.name}</p>
                                  <KeyValuePairs
                                    pairs={[
                                      {
                                        key: 'Email',
                                        value: (
                                          <Input
                                            type="email"
                                            onChange={({ target }) =>
                                              this.setStateProperty('smtpEmail', target.value)
                                            }
                                            value={this.state.smtpEmail}
                                            name="smtpEmail"
                                            placeholder="Email Address"
                                          />
                                        )
                                      },
                                      {
                                        key: 'Password',
                                        value: (
                                          <Input
                                            type="password"
                                            onChange={({ target }) =>
                                              this.setStateProperty('smtpPassword', target.value)
                                            }
                                            value={this.state.smtpPassword}
                                            name="smtpPassword"
                                            placeholder="Password"
                                          />
                                        )
                                      }
                                    ]}
                                  />
                                  <Button
                                    onClick={() =>
                                      this.saveSmtpCredentials(() => {
                                        this.setState({
                                          showCredentialsForm: false
                                        })
                                      })
                                    }
                                    className={s.saveBtn}
                                    disabled={!this.state.smtpPassword || !this.state.smtpEmail}
                                  >
                                    Save Credentials
                                  </Button>
                                </>
                              )}
                              <Button
                                onClick={this.testSmtpConnection}
                                className={s.testConnection}
                                color="secondary"
                              >
                                Test Connection
                              </Button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col xl="9">
                    <div className={s.detailsContainer}>
                      <div className={s.title}>
                        <FaRegImage className={s.faIcon} />
                        Profile Details
                      </div>
                      <div className={s.container}>
                        <Form onSubmit={handleSubmit}>
                          <div className={s.underlineTitle}>
                            <span>General Information</span>
                          </div>
                          <FormGroup>
                            <Container>
                              <Row>
                                <Col className={s.colForm} lg="6">
                                  <div className={s.fieldWrapper}>
                                    <Label className={s.formLabel} for="firstName">
                                      First Name *
                                    </Label>
                                    <Input
                                      type="text"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.firstName}
                                      name="firstName"
                                      placeholder="Enter First Name"
                                      disabled={isSubmitting}
                                    />
                                    {errors.firstName && touched.firstName && (
                                      <div className={s.inputFeedback}>{errors.firstName}</div>
                                    )}
                                  </div>
                                  <div className={s.fieldWrapper}>
                                    <Label className={s.formLabel} for="title">
                                      Title
                                    </Label>
                                    <Input
                                      type="text"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.title}
                                      name="title"
                                      placeholder="Enter Title"
                                      disabled={isSubmitting}
                                    />
                                  </div>
                                  <div className={s.fieldWrapper}>
                                    <Label className={s.formLabel} for="phone">
                                      Phone
                                    </Label>
                                    <Input
                                      type="text"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.phone}
                                      name="phone"
                                      placeholder="555-555-5555"
                                      disabled={isSubmitting}
                                    />
                                  </div>
                                  <div className={s.fieldWrapper}>
                                    <Label className={s.formLabel} for="fax">
                                      Fax
                                    </Label>
                                    <Input
                                      type="text"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.fax}
                                      name="fax"
                                      placeholder="Enter Fax"
                                      disabled={isSubmitting}
                                    />
                                  </div>
                                  <div className={s.fieldWrapper}>
                                    <Label className={s.formLabel} for="cellPhone">
                                      Cell Phone
                                    </Label>
                                    <Input
                                      type="text"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.cellPhone}
                                      name="cellPhone"
                                      placeholder="Enter Cell Phone"
                                      disabled={isSubmitting}
                                    />
                                  </div>
                                </Col>
                                <Col className={s.colForm} lg="6">
                                  <div className={s.fieldWrapper}>
                                    <Label className={s.formLabel} for="lastName">
                                      Last Name *
                                    </Label>
                                    <Input
                                      type="text"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.lastName}
                                      name="lastName"
                                      placeholder="Enter Last Name"
                                      disabled={isSubmitting}
                                    />
                                    {errors.lastName && touched.lastName && (
                                      <div className={s.inputFeedback}>{errors.lastName}</div>
                                    )}
                                  </div>
                                  <div className={s.fieldWrapper}>
                                    <Label className={s.formLabel} for="teams">
                                      Teams
                                    </Label>
                                    <Select
                                      isSearchable
                                      placeholder="Select an option"
                                      name="teams"
                                      value={values.teams}
                                      onChange={e =>
                                        this.handleChange(e, values, setFieldValue, 'teams')
                                      }
                                      options={toTeams(allTeams)}
                                      isDisabled={isSubmitting}
                                      isMulti
                                    />
                                  </div>
                                  <div className={s.fieldWrapper}>
                                    <Label className={s.formLabel} for="department">
                                      Department
                                    </Label>
                                    <Select
                                      isSearchable
                                      placeholder="Select an option"
                                      name="department"
                                      value={values.department}
                                      onChange={value =>
                                        this.handleChange(
                                          value,
                                          values,
                                          setFieldValue,
                                          'department'
                                        )
                                      }
                                      options={toDepartments(departments)}
                                      isDisabled={isSubmitting}
                                    />
                                  </div>
                                  <div className={s.fieldWrapper}>
                                    <Label className={s.formLabel} for="timezone">
                                      Timezone
                                    </Label>
                                    <Select
                                      isSearchable
                                      placeholder="Select a timezone"
                                      name="timezone"
                                      value={values.timezone}
                                      onChange={value =>
                                        this.handleChange(value, values, setFieldValue, 'timezone')
                                      }
                                      options={this.state.timezones}
                                      isDisabled={isSubmitting}
                                    />
                                  </div>
                                  <div className={s.fieldWrapper}>
                                    <Label className={s.formLabel} for="email">
                                      Email *
                                    </Label>
                                    <Input
                                      type="email"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.email}
                                      name="email"
                                      placeholder="Enter Email"
                                      disabled
                                    />
                                    {errors.email && touched.email && (
                                      <div className={s.inputFeedback}>{errors.email}</div>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </Container>
                          </FormGroup>
                          <div className={s.underlineTitle}>
                            <span>Mailing Address</span>
                          </div>
                          <FormGroup>
                            <Container>
                              <div className={s.fieldWrapper}>
                                <Label className={s.formLabel} for="address">
                                  Address
                                </Label>
                                <GoogleAutocomplete
                                  className={s.googleAutocomplete}
                                  value={values.address}
                                  name="address"
                                  onChange={e =>
                                    this.handleChange(e, values, setFieldValue, 'address')
                                  }
                                  onSelectCallback={e =>
                                    selectGoogleAutocomplete(e, values, setFieldValue)
                                  }
                                  onBlur={() => blurGoogleAutocomplete(values, setFieldValue)}
                                />
                              </div>
                              <div className={s.fieldWrapper}>
                                <Label className={s.formLabel} for="address2">
                                  Street 1
                                </Label>
                                <Input
                                  type="text"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.address2}
                                  name="address2"
                                  placeholder="Enter Street Address"
                                  disabled={isSubmitting}
                                />
                              </div>
                              <div className={s.fieldWrapper}>
                                <Label className={s.formLabel} for="street2">
                                  Street 2
                                </Label>
                                <Input
                                  type="text"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.street2}
                                  name="street2"
                                  placeholder="Enter Street Address"
                                  disabled={isSubmitting}
                                />
                              </div>
                              <Row className={s.rowForm}>
                                <Col className={s.colForm} lg="4">
                                  <Label className={s.formLabel} for="city">
                                    City
                                  </Label>
                                  <Input
                                    type="text"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.city}
                                    name="city"
                                    placeholder="Enter City"
                                    disabled={isSubmitting}
                                  />
                                </Col>
                                <Col className={s.colForm} lg="4">
                                  <Label className={s.formLabel} for="state">
                                    State/Province/Region
                                  </Label>
                                  <Input
                                    type="text"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.state}
                                    name="state"
                                    placeholder="Enter State/Province/Region"
                                    disabled={isSubmitting}
                                  />
                                </Col>
                                <Col className={s.colForm} lg="4">
                                  <Label className={s.formLabel} for="zipcode">
                                    Zip/Postal Code
                                  </Label>
                                  <Input
                                    type="text"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.zipcode}
                                    name="zipcode"
                                    placeholder="Enter Zip/Postal Code"
                                    disabled={isSubmitting}
                                  />
                                </Col>
                              </Row>
                            </Container>
                          </FormGroup>
                          <Button className={s.saveFrom} type="submit">
                            Save
                          </Button>
                        </Form>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            )
          }}
        </Formik>
        <Formik
          props={this.props}
          enableReinitialize
          initialValues={{ currentPassword, newPassword, confirmNewPassword }}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.changePassword(values)
            setSubmitting(false)
            resetForm()
          }}
          validationSchema={Yup.object().shape({
            currentPassword: Yup.string().required('Current Password is required'),
            newPassword: Yup.string().required('New Password is required'),
            confirmNewPassword: Yup.string()
              .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
              .required('Confirm New Password is required')
          })}
        >
          {props => {
            const {
              values,
              touched,
              errors,
              isSubmitting,
              handleBlur,
              handleChange,
              handleSubmit
            } = props
            return (
              <Container className={cn(s.mainContainer, s.topMargin)}>
                <Row>
                  <Col xl={{ size: 9, offset: 3 }}>
                    <div className={s.detailsContainer}>
                      <div className={s.title}>
                        <FaKey className={s.faIcon} />
                        Change Password
                      </div>
                      <div className={s.container}>
                        <Form onSubmit={handleSubmit}>
                          <FormGroup>
                            <Container>
                              <Row>
                                <Col className={s.colForm} lg="6">
                                  <div className={s.fieldWrapper}>
                                    <Label className={s.formLabel} for="currentPassword">
                                      Current Password *
                                    </Label>
                                    <Input
                                      type="password"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.currentPassword}
                                      name="currentPassword"
                                      placeholder="Enter Current Password"
                                      disabled={isSubmitting}
                                    />
                                    {errors.currentPassword && touched.currentPassword && (
                                      <div className={s.inputFeedback}>
                                        {errors.currentPassword}
                                      </div>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col className={s.colForm} lg="6">
                                  <div className={s.fieldWrapper}>
                                    <Label className={s.formLabel} for="newPassword">
                                      New Password *
                                    </Label>
                                    <Input
                                      type="password"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.newPassword}
                                      name="newPassword"
                                      placeholder="Enter New Password"
                                      disabled={isSubmitting}
                                    />
                                    {errors.newPassword && touched.newPassword && (
                                      <div className={s.inputFeedback}>{errors.newPassword}</div>
                                    )}
                                  </div>
                                </Col>
                                <Col className={s.colForm} lg="6">
                                  <div className={s.fieldWrapper}>
                                    <Label className={s.formLabel} for="confirmNewPassword">
                                      Confirm New Password *
                                    </Label>
                                    <Input
                                      type="password"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.confirmNewPassword}
                                      name="confirmNewPassword"
                                      placeholder="Enter Confirm New Password"
                                      disabled={isSubmitting}
                                    />
                                    {errors.confirmNewPassword && touched.confirmNewPassword && (
                                      <div className={s.inputFeedback}>
                                        {errors.confirmNewPassword}
                                      </div>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </Container>
                          </FormGroup>
                          <Button className={s.saveFrom} type="submit">
                            Change
                          </Button>
                        </Form>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            )
          }}
        </Formik>
      </>
    )
  }
}

export default ProfileContainer
